import Peer from 'skyway-js'; //SkyWay SDK 読み込み
import _ from 'lodash'

function SoundMeter(context) {
  this.context = context;
  this.instant = 0.0;
  this.script = context.createScriptProcessor(2048, 1, 1);
  const that = this;
  this.script.onaudioprocess = function(event) {
    const input = event.inputBuffer.getChannelData(0);
    let i;
    let sum = 0.0;
    let clipcount = 0;
    for (i = 0; i < input.length; ++i) {
      sum += input[i] * input[i];
      if (Math.abs(input[i]) > 0.99) {
        clipcount += 1;
      }
    }
    that.instant = Math.sqrt(sum / input.length);
  };
}

SoundMeter.prototype.connectToSource = function(stream, callback) {
  console.log('SoundMeter connecting');
  try {
    this.mic = this.context.createMediaStreamSource(stream);
    this.mic.connect(this.script);
    // necessary to make sample run, but should not be.
    this.script.connect(this.context.destination);
    if (typeof callback !== 'undefined') {
      callback(null);
    }
  } catch (e) {
    console.error(e);
    if (typeof callback !== 'undefined') {
      callback(e);
    }
  }
};

const state = {
  call: null,
  peer: null,
  peerShare: null,
  peerId:null,
  peerIdShare:null,
  localVideo: null,
  localVideoShare: null,
  remoteVideo: null,
  localStream: null,
  localStreamShare: null,
  remoteStreams: [],
  peerConnection: null,
  peerConnectionShare: null,
  existingRoom: null,
  existingRoomShare: null,
  negotiationneededCounter: 0,
  roomName: '',
  userName: '',
  uid: '',
  isOffer: false,
  isMute: false,
  isBlind: false,
  waitingPeer: null,
  waitingRoom: null,
  memberNum: 0,
  roomMembers: {},
  music: '',
  getVolume: 0,
  chatMessages: [],
  requestData: [],
  requestOnlyData: {},
  ownRequest: null
}
// TODO: Vuexじゃないとこでやりたい
const actions = {
  setVideo ({commit}, data) {
    commit('SET_VIDEO', data)
  },
  setVideoShare ({commit}, data) {
    commit('SET_VIDEO_SHARE', data)
  },
  playVideo ({commit}) {
    commit('PLAY_VIDEO')
  },
  playVideoShare ({commit}, {video, stream}) {
    commit('PLAY_VIDEO_SHARE', {video, stream})
  },
  setVideoSwitch ({commit}, sw) {
    commit('SET_VSW', sw)
  },
  setAudioSwitch ({commit}, sw) {
    commit('SET_ASW', sw)
  },
  makeCall({commit}, stream){
    commit('MAKE_CALL', stream)
  },
  makeCallShare({commit}, stream){
    commit('MAKE_CALL_SHARE', stream)
  },
  connect({commit}, call){
    commit('CONNECT', call)
  },
  connectShare({commit}, call){
    commit('CONNECT_SHARE', call)
  },
  addVideo({commit}, stream){
    commit('ADD_VIDEO', stream)
  },
  removeVideo({commit}, id){
    commit('REMOVE_VIDEO', id)
  },
  removeAllRemoteVideos({commit}){
    commit('REMOVE_ALL_VIDEOS')
  },
  endCall({commit}){
    commit('END_CALL')
  },
  endCallShare({commit}){
    commit('END_CALL_SHARE')
  },
  waitingConnect ({commit}) {
    commit('WAITING_CONNECT')
  },
  waitingConnectAndRequest ({commit}, data) {
    commit('WAITING_CONNECT_REQ', data)
  },
  waitingDisconnect ({commit}) {
    commit('WAITING_DISCONNECT')
  },
  getVolume ({commit}) {
    commit('GET_VOLUME')
  },
  sendMessage ({commit}, data) {
    commit('SEND_MSG', data)
  },
  setRequestData ({commit}, data) {
    commit('SET_REQ_DATA', data)
  }
}
const mutations = {
  async SET_VIDEO (state, data) {
    state.localVideo = data.video
    state.roomName = data.room
    if (!navigator.mediaDevices) alert('申し訳ございませんが、 お開きのブラウザはサポートされておりません。')
    if (state.localStream) {
      state.localStream.getTracks().forEach((track) => {
        track.stop()
      })
    }
    const userAgent = window.navigator.userAgent.toLowerCase()
    // firefoxの場合、frameRateが使えない
    if(userAgent.indexOf('firefox') != -1) {
      state.localStream = await navigator.mediaDevices.getUserMedia({
        video: {
            width: {
                min: 320,
                max: 320
            },
            height: {
                min: 240,
                max: 240
            },
            facingMode: 'user',
            advanced: [
            {
              aspectRatio: 1.33333333333
            }, {
              aspectRatio: 1
            }, {
              echoCancellation: {
                exact: true
              }
            }, {
              googEchoCancellation: {
                exact: true
              }
            }, {
              googExperimentalEchoCancellation: {
                exact: true
              }
            }, {
              googNoiseSuppression: {
                exact: true
              }
            }, {
              googExperimentalNoiseSuppression: {
                exact: true
              }
            }, {
              googAutoGainControl: {
                exact: true
              }
            }, {
              googExperimentalAutoGainControl: {
                exact: true
              }
            }, {
              googHighpassFilter: {
                exact: true
              }
            }, {
              googTypingNoiseDetection: {
                exact: true
              }
            }, {
              googAudioMirroring: {
                exact: false
              }
            }, {
              deviceId: {
                exact: ["default"]
              }
            }]
        },
        audio: true
      })
    } else {
      state.localStream = await navigator.mediaDevices.getUserMedia({
        video: {
            width: {
                min: 320,
                max: 320
            },
            height: {
                min: 240,
                max: 240
            },
            // firefoxで使えない
            frameRate: {
                min: 1,
                max: 15
            },
            facingMode: 'user',
            advanced: [
            {
              aspectRatio: 1.33333333333
            }, {
              aspectRatio: 1
            }, {
              echoCancellation: {
                exact: true
              }
            }, {
              googEchoCancellation: {
                exact: true
              }
            }, {
              googExperimentalEchoCancellation: {
                exact: true
              }
            }, {
              googNoiseSuppression: {
                exact: true
              }
            }, {
              googExperimentalNoiseSuppression: {
                exact: true
              }
            }, {
              googAutoGainControl: {
                exact: true
              }
            }, {
              googExperimentalAutoGainControl: {
                exact: true
              }
            }, {
              googHighpassFilter: {
                exact: true
              }
            }, {
              googTypingNoiseDetection: {
                exact: true
              }
            }, {
              googAudioMirroring: {
                exact: false
              }
            }, {
              deviceId: {
                exact: ["default"]
              }
            }]
        },
        audio: true
      })
    }
    state.isOffer = true
    state.localVideo.srcObject = state.localStream
    state.localStream.getVideoTracks()[0].enabled = !state.isBlind
    state.localStream.getAudioTracks()[0].enabled = !state.isMute
    if (data.connect) {
      state.userName = data.userName ? data.userName : ''
      this._actions['webRTC/playVideo'][0]()
    }
    this._actions['webRTC/getVolume'][0]()
  },
  async SET_VIDEO_SHARE (state, data) {
    state.localVideoShare = data.video
    state.roomName = data.room
    if (!navigator.mediaDevices) alert('申し訳ございませんが、 お開きのブラウザはサポートされておりません。')
    if (state.localStreamShare) {
      state.localStreamShare.getTracks().forEach((track) => {
        track.stop()
      })
    }
    state.localStreamShare = await navigator.mediaDevices.getDisplayMedia({video: true, audio: false})
    state.isOffer = true
    this._actions['webRTC/playVideoShare'][0]({video: state.localVideoShare, stream: state.localStreamShare})
  },
  async PLAY_VIDEO (state) {
    let video = state.localVideo
    let stream = state.localStream
    if (!video || !stream) return
    await video.play()
    // peerオブジェクトの作成
    state.peer = new Peer({key: 'e8d0e478-5ce8-4dd0-888b-d267a5d83f14', debug: 3}); //新規にPeerオブジェクトの作成
    state.id = state.peer.id
    // openイベント SkyWayを利用する準備が整ったら発火
    state.peer.on('open', () => {
      state.peerId = state.peer.id
      this._actions['webRTC/makeCall'][0](stream)
    })
    // callイベント 相手から接続要求が来た時に発火
    state.peer.on('call', call => {
      call.answer(state.localStream, { videoCodec: 'H264', audioBandwidth: 48 })
      this._actions['webRTC/connect'][0](call)
    })
    // errorイベント
    state.peer.on('error', err => {
      console.log(err.message);
    })
  },
  async PLAY_VIDEO_SHARE (state, {video, stream}) {
    video.srcObject = stream
    await video.play()
    // peerオブジェクトの作成
    state.peerShare = new Peer({key: 'e8d0e478-5ce8-4dd0-888b-d267a5d83f14', debug: 3}); //新規にPeerオブジェクトの作成
    // openイベント SkyWayを利用する準備が整ったら発火
    state.peerShare.on('open', () => {
      state.peerIdShare = state.peerShare.id
      this._actions['webRTC/makeCallShare'][0](stream)
    })
    // callイベント 相手から接続要求が来た時に発火
    state.peerShare.on('call', call => {
      call.answer(state.localStreamShare, { videoCodec: 'H264', audioBandwidth: 48 })
      this._actions['webRTC/connectShare'][0](call)
    })
    // errorイベント
    state.peerShare.on('error', err => {
      console.log(err.message);
    })
  },
  // 発信処理
  MAKE_CALL (state, stream) {
    console.log("MAKE_CALL") 
    state.music = new Audio();
    state.music.preload = "auto";
    state.music.src = require('@/assets/template/chime.mp3');
    state.music.load();
    let roomName = state.roomName
    if (!roomName) {
      return
    }
    state.call = state.peer.joinRoom(roomName, {mode: 'sfu', stream: stream}, {videoBandWidth: 200, audioBandwidth: 200, videoCodec: 'H264', audioCodec	: 'Opus'});
    this._actions['webRTC/connect'][0](state.call)
  },
  // 発信処理
  MAKE_CALL_SHARE (state, stream) {
    console.log("MAKE_CALL_SHARE") 
    let roomName = state.roomName
    if (!roomName) {
      return
    }
    const call = state.peerShare.joinRoom(roomName, {mode: 'sfu', stream: stream}, {videoBandWidth: 200, audioBandwidth: 200, videoCodec: 'H264', audioCodec	: 'Opus'});
    this._actions['webRTC/connectShare'][0](call)
  },
  // 切断処理
  END_CALL (state) {
    if (state.localStream) {
      state.localStream.getTracks().forEach((track) => {
        track.stop()
      })
    }
    if (state.localStreamShare) {
      state.localStreamShare.getTracks().forEach((track) => {
        track.stop()
      })
    }
    if (state.existingRoom) state.existingRoom.close()
    if (state.existingRoomShare) state.existingRoomShare.close()
    state.existingRoom = null
    state.existingRoomShare = null
    state.localStream = null
    state.localStreamShare = null
    if (state.localVideo) {
      state.localVideo.srcObject = null
      state.localVideo = null
    }
    if (state.localVideoShare) {
      state.localVideoShare.srcObject = null
      state.localVideoShare = null
    }
  },
  // 切断処理
  END_CALL_SHARE (state) {
    if (state.localStreamShare) {
      state.localStreamShare.getTracks().forEach((track) => {
        track.stop()
      })
    }
    state.existingRoomShare.close()
    state.existingRoomShare = null
    state.localStreamShare = null
    if (state.localVideoShare) {
      state.localVideoShare.srcObject = null
      state.localVideoShare = null
    }
  },
  CONNECT (state, call) {
    if (state.existingRoom){
      state.existingRoom.close()
    }
    state.existingRoom = call
    call.on('open', () => {
      call.send(JSON.stringify({type: '[status]', name: state.userName, mute: state.isMute, blind: state.isBlind, share: false}))
      let id = setInterval(() => {
        if (state.waitingPeer && state.waitingPeer.open && state.waitingRoom) {
          state.waitingRoom.send('[Connect]')
          clearInterval(id)
        } else {
          this._actions['webRTC/waitingConnect'][0]()
        }
      }, 1000);
    })

    call.getLog()
    call.once('log', logs => {
      let members = {}
      for (let i = 0; i < logs.length; i++) {
        const log = JSON.parse(logs[i])
        const src = log.message.src
        if (log.messageType == 'ROOM_DATA') {
          const data = JSON.parse(log.message.data)
          if (data.type == '[status]') {
            members[src] = {name: data.name, mute: data.mute, blind: data.blind, share: data.share}
          } else if (data.type === '[chat]') {
            // chatの場合
            state.chatMessages.push({
              name: data.name,
              peerId: state.peerId,
              mute: data.mute,
              blind: data.blind,
              share: data.share,
              message: data.message,
              speaker: 'other',
              createdAt: data.createdAt
            })
          }
        }
        if (log.messageType == 'ROOM_USER_JOIN') {
          if (!members[src]) members[src] = {}
        }
        if (log.messageType == 'ROOM_USER_LEAVE') {
          delete members[src]
        }
      }
      state.roomMembers = members
    })

    call.on('stream', stream => {
      this._actions['webRTC/addVideo'][0](stream)
    })

    call.on('data', ({src, data}) => {
      const param = JSON.parse(data)
      // ステータスの場合
      if (param.type === '[status]') {
        let members = {}
        // なぜか1つづつコピーしないといけない
        for (let key of Object.keys(state.roomMembers)) {
          members[key] = state.roomMembers[key]
        }
        members[src] = {name: param.name, mute: param.mute, blind: param.blind, share: param.share, volume: param.volume}
        state.roomMembers = members
      } else if (param.type === '[chat]') {
        // chatの場合
        state.chatMessages.push({
          name: param.name,
          peerId:param.peerid,
          mute: param.mute,
          blind: param.blind,
          share: param.share,
          message: param.message,
          speaker: 'other',
          createdAt: param.createdAt
        })
      }
    })

    call.on('close', () => {
      this._actions['webRTC/removeAllRemoteVideos'][0]()
      if (state.waitingRoom) state.waitingRoom.send('[Disconnect]')
    })

    call.on('peerLeave', peerId => {
      let members = {}
      for (let key of Object.keys(state.roomMembers)) {
        if (key != peerId) members[key] = state.roomMembers[key]
      }
      state.roomMembers = members
      this._actions['webRTC/removeVideo'][0](peerId)
    })
  },
  CONNECT_SHARE (state, call) {
    if (state.existingRoomShare){
      state.existingRoomShare.close()
    }
    state.existingRoomShare = call
    call.on('open', () => {
      call.send(JSON.stringify({type: '[status]', name: state.userName + '[共有]', mute: state.isMute, blind: state.isBlind, share: true, volume: state.getVolume}))
    })
  },
  ADD_VIDEO (state, stream) {
    if (state.music.paused) {
      state.music.play();
    }
    let tempStream = stream
    // 画面共有の場合ミュート
    // Debug用
    // if (tempStream.getTracks().length < 2) {
    //   console.log('@@@', tempStream.getTracks())
    //   console.log('@@@', tempStream.getTracks().getConstraints())
    //   console.log('@@@', tempStream.getTracks().getSettings())
    // }
    state.remoteStreams.push(tempStream)
  },
  REMOVE_VIDEO (state, peerId) {
    state.remoteStreams.forEach((item, index) => {
      if(item.peerId === peerId){
        state.remoteStreams.splice(index, 1)
      }
    })
  },
  REMOVE_ALL_VIDEOS (state) {
    state.remoteStreams = []
  },
  SET_VSW (state, sw) {
    state.isBlind = !sw
    if (state.existingRoom) state.existingRoom.send(JSON.stringify({type: '[status]', name: state.userName, mute: state.isMute, blind: state.isBlind, share: false}))
    if (state.localStream) {
      state.localStream.getVideoTracks()[0].enabled = sw
    }
  },
  SET_ASW (state, sw) {
    state.isMute = !sw
    if (state.existingRoom) state.existingRoom.send(JSON.stringify({type: '[status]', name: state.userName, mute: state.isMute, blind: state.isBlind, share: false}))
    if (state.localStream) {
      state.localStream.getAudioTracks()[0].enabled = sw
    }
  },
  async WAITING_CONNECT (state) {
    if (state.waitingRoom) state.waitingRoom.close()
    if (state.waitingPeer) state.waitingPeer.destroy()
    state.memberNum = 0
    // 接続情報をやりとりするConnection
    state.waitingPeer = new Peer({key: 'e8d0e478-5ce8-4dd0-888b-d267a5d83f14', debug: 3}); //新規にPeerオブジェクトの作成
    // openイベント SkyWayを利用する準備が整ったら発火
    state.waitingPeer.on('open', () => {
      const roomName = state.roomName
      if (!roomName) {
        return
      }
      state.memberNum = 0
      try {
        state.waitingRoom = state.waitingPeer.joinRoom(roomName + '_waiting_', {mode: 'sfu'}, {videoBandWidth: 200, audioBandwidth: 200, videoCodec: 'H264', audioCodec	: 'Opus'});
      } catch (e) {
        state.waitingRoom = null
      }

      state.waitingRoom.getLog()
      state.waitingRoom.once('log', logs => {
        for (let i = 0; i < logs.length; i++) {
          const log = JSON.parse(logs[i])
          if (log.messageType == 'ROOM_DATA') {
            if (log.message.data == '[Connect]') {
              state.memberNum++
            }
            else if (log.message.data == '[Disconnect]') {
              state.memberNum--
            }
          }
        }
      })

      state.waitingRoom.on('data', ({src, data}) => {
          if (data == '[Connect]') {
          state.memberNum++
        } else if (data == '[Disconnect]') {
          state.memberNum--
        } else if (/\[REQUEST\]/.test(data)) {
          let dataLog = JSON.parse(data.replace('[REQUEST]', ''))
          let pushFlg = true
          for (const req of state.requestData) {
            if (req.id === dataLog.id) pushFlg = false
          }
          if (pushFlg) {
            state.requestOnlyData = { 
              flg : false,
              name: dataLog.userName,
              id: dataLog.id,
            }
            state.requestData.push({
              flg : false,
              name: dataLog.userName,
              id: dataLog.id,
            })
          }
        } else if (/\[RECEIVED\]/.test(data)) {
          let dataLog = JSON.parse(data.replace('[RECEIVED]', ''))
          for (let i in state.requestData) {
            if (dataLog.id === state.requestData[i].id) {
              state.requestData.splice(i, 1)
              if (state.ownRequest.id === dataLog.id) {
                state.ownRequest.flg = true
                if (dataLog.flg) {
                  state.ownRequest.request = "OK"
                } else {
                  state.ownRequest.request = "NG"
                }
              }
            }
          }
        } else if (/\[SYNC\]/.test(data)) {
          state.requestData = JSON.parse(data.replace('[SYNC]', ''))
        }
      })

      state.waitingRoom.on('close', () => {
        state.memberNum = 0
      })

    })
    // errorイベント
    state.waitingPeer.on('error', err => {
      console.log(err.message);
    })
  },
  async WAITING_CONNECT_REQ (state, data) {
    let dataTemp = data
    dataTemp.flg = false
    state.ownRequest = dataTemp
    state.requestData.push(dataTemp)
    state.waitingRoom.send('[REQUEST]' + JSON.stringify(data))
  },
  WAITING_DISCONNECT (state) {
    state.memberNum = 0
    if (state.waitingRoom) {
      state.waitingRoom.close()
      state.waitingRoom = null
    }
    if (state.waitingPeer) {
      state.waitingPeer.destroy()
      state.waitingPeer = null
    }
    if (state.localStream) {
      state.localStream.getTracks().forEach((track) => {
        track.stop()
      })
    }
    state.localStream = null
    if (state.localVideo) {
      state.localVideo.srcObject = null
      state.localVideo = null
    }
  },
  GET_VOLUME (state) {
    try {
      window.AudioContext = window.AudioContext || window.webkitAudioContext
      window.audioContext = new AudioContext()
    } catch (e) {
      console.error('Web Audio API not supported.')
    }
    const soundMeter = window.soundMeter = new SoundMeter(window.audioContext)
    let meterRefresh = null
    soundMeter.connectToSource(state.localStream, function(e) {
      if (e) {
        console.error(e)
        return
      }
      meterRefresh = setInterval(() => {
        state.getVolume = soundMeter.instant.toFixed(2) * 2
        state.call.send(JSON.stringify({type: '[status]', name: state.userName, mute: state.isMute, blind: state.isBlind, share: false, volume: state.getVolume}))
      }, 200)
    })
  },
  SEND_MSG (state, data) {
    state.call.send(
      JSON.stringify(
        {
          type: '[chat]',
          message: data,
          name: state.userName,
          peerid:state.peerId,
          mute: state.isMute,
          blind: state.isBlind,
          share: false,
          createdAt: new Date()
        }
      )
    )
    state.chatMessages.push({
      name: state.userName,
      peerid:state.peerId,
      mute: state.isMute,
      blind: state.isBlind,
      share: false,
      message: data,
      speaker: 'my',
      createdAt: new Date()
    })
  },
  SET_REQ_DATA (state, data) {
    for (let i in state.requestData) {
      if (data.id === state.requestData[i].id) {
        state.requestData.splice(i, 1)
      }
    }
    state.waitingRoom.send('[RECEIVED]' + JSON.stringify(data))
    state.waitingRoom.send('[SYNC]' + JSON.stringify(state.requestData))
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/webRTC.js